
import { SaleEditButtons } from "@/models/user-configs/sale-settings";
import { SaleService } from "@/services";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";



export default Vue.extend({
	data(){
		return {
			items: [] as ISelectItem<string>[]
		};
	},
	props: {
		value: {
			type: Array as ()=>string[],
			required: true
		},
		defaultSettings: {
			type: Array as ()=>string[],
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		}
	},
	computed: {
		dropdownItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("restore-default-settings"),
					value: this.restoreDefaultSettings
				}
			];
		}
	},
	methods: {
		updateValue(){
			this.$emit("input", this.items.filter(i=>!i.disabled).map(i=>i.value));
		},
		toggleDisabled(item:ISelectItem<string>){
			item.disabled = !item.disabled;
			this.updateValue();
		},
		async restoreDefaultSettings(){
			console.log("Defaukt:", this.defaultSettings);
			this.$emit("input", [...this.defaultSettings]);
			await this.$nextTick();
			this.initializeItems();
		},
		initializeItems(){
			let keys = getEnumKeys(SaleEditButtons);
			let items = keys.map(k=>{
				let value = getEnumValueFromKey(SaleEditButtons, k);
				return {
					text: this.$ct(`sale-edit-buttons.${k}`),
					value,
					disabled: this.value.indexOf(value) == -1
				} as ISelectItem<string>;
			});
			for (let item of SaleService.saleEditExtraButtonScripts){
				let value = `script-button-${item.ID}`;
				items.push({
					text: item.Name,
					value,
					disabled: this.value.indexOf(value) == -1
				});
			}
			items.sort((a, b)=>{
				let ia = this.value.indexOf(a.value);
				let ib = this.value.indexOf(b.value);
				if (ia == ib) return 0;
				if (ia == -1) return 1;
				if (ib == -1) return -1;
				return ib-ia;
			});
			this.items = items;
		}
	},
	mounted(){
		this.initializeItems();
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
